<template>
    <div>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title"><i class="fas fa-dollar-sign"></i> Invoices</h4>
                    <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'dashboard'}">Home</router-link>
                                </li>
                                <li class="breadcrumb-item">
                                    <router-link :to="{ name: 'expressinvoices'}">Invoices</router-link>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div class="col-7 align-self-center">
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "InvoiceLayout"
    }
</script>

<style scoped>

</style>
